module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/invoice/assets/img/invoice_icon.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/invoice/assets/img/invoice_icon.png
// module id = 1456
// module chunks = 418